import { Group, Skeleton } from '@mantine/core';
import { useTheme } from '@emotion/react';

import useStyles from './useStyles';

type ContestDetailSkeletonProps = {
  isSidePanel?: boolean;
};

function ContestDetailSkeleton({ isSidePanel }: ContestDetailSkeletonProps) {
  const theme = useTheme();
  const { classes } = useStyles({ isSidePanel });

  return (
    <>
      <Skeleton className={classes.skeletonHeader} data-skeleton-name="header" />
      <section className={classes.contentContainer}>
        <div className={classes.content}>
          <Group spacing={theme.spacing.xl * 2} className={classes.main}>
            <Group w="100%">
              <Skeleton w={300} h={30} data-skeleton-name="myentriesTitle" />
              <Skeleton h={320} data-skeleton-name="myentries" />
            </Group>

            <Group w="100%">
              <Skeleton w={300} h={30} data-skeleton-name="aboutTitle" />
              <Skeleton h={320} data-skeleton-name="about" />
            </Group>

            <Group w="100%">
              <Skeleton w={300} h={30} data-skeleton-name="prizeTitle" />
              <Skeleton h={200} data-skeleton-name="prize" />
            </Group>

            <Group w="100%">
              <Skeleton w={300} h={30} data-skeleton-name="rulesTitle" />
              <Skeleton h={200} data-skeleton-name="rules" />
            </Group>
          </Group>
          <aside className={classes.side}>
            <Group w={260}>
              <Skeleton w="100%" h={30} data-skeleton-name="entriesTitle" />
              <Skeleton w="100%" h={600} data-skeleton-name="entries" />
            </Group>
          </aside>
        </div>
      </section>
    </>
  );
}

export default ContestDetailSkeleton;
